import { Component, ElementRef, OnInit, ViewChild } from "@angular/core";
import { FieldType, FieldTypeConfig } from "@ngx-formly/core";
import { DomSanitizer } from "@angular/platform-browser";

@Component({
  selector: "formly-field-file",
  template: `
    <div class="upload-wrapper">
      <div class="file-container">
        <div class="file" *ngFor="let file of selectedFiles; let i = index">
          <div class="image-container">
            <div class="icon" (click)="onDelete(i)">
              <span>x</span>
            </div>
            <div class="image">
              <img [src]="getSanitizedImageUrl(file)" />
            </div>
          </div>
          <div class="descriptionText">{{ file.name || "Nessun file caricato." }}</div>
        </div>
      </div>
      <div
        class="upload-container"
        (click)="openFileInput()"
        [ngClass]="{
          'neutral-1-bg-a2 neutral-2-border-color-b4': formControl.disabled,
        }"
      >
        <div class="mask"></div>
        <div
          class="helper-text"
          [ngClass]="{
            'cursor-not-allowed': formControl.disabled,
          }"
        >
          <div class="absolute-div">
            <div [ngClass]="{ ' neutral-2-color-b4 cursor-not-allowed': formControl.disabled }">Upload file</div>
          </div>
        </div>
        <input
          #fileinput
          [multiple]="props['multiple']"
          id="file-input"
          type="file"
          [formControl]="formControl"
          [formlyAttributes]="field"
          (change)="onChange($event)"
           [attr.accept]="props['accept'] || '.png,.jpg,.pdf'"
          style="display: none"
        />
      </div>
    </div>
  `,
  styleUrls: ["./file-type.component.scss"],
})
export class FormlyFieldFile extends FieldType<FieldTypeConfig> {

  @ViewChild("fileinput") el?: ElementRef;

  selectedFiles?: File[];

  constructor(public sanitizer: DomSanitizer) {
    super();
  }

  ngOnInit(): void {

  }

  openFileInput() {
    this.el!.nativeElement.click();
  }


  onDelete(index: number) {
    this.selectedFiles!.splice(index, 1);
    this.formControl.patchValue(this.selectedFiles);
    const input = document.getElementById('file-input') as HTMLInputElement;
    if (input) input.value = '';
  }

  onChange(event: any) {
    const files: FileList | null = event.target.files;
    if (!files || files.length === 0) {
      return; // Ignora se l'utente annulla la selezione
    }

    const newFiles: File[] = Array.from(files);

    const existing: File[] = this.selectedFiles || [];
    const merged: File[] = [...existing];

    for (const file of newFiles) {
      if (!(file instanceof File)) continue;

      const isDuplicate = existing.some(f => f.name === file.name && f.size === file.size);
      if (!isDuplicate) {
        merged.push(file);
      }
    }

    this.selectedFiles = merged;
  }



  private fileIcons: { [key: string]: string } = {
    pdf: 'assets/img/icon-pdf.png',
    doc: 'assets/svg/file-doc.svg',
    docx: 'assets/svg/file-doc.svg',
    xls: 'assets/svg/file-excel.svg',
    xlsx: 'assets/svg/file-excel.svg',
    zip: 'assets/svg/file-zip.svg',
    rar: 'assets/svg/file-zip.svg'
  };

  getSanitizedImageUrl(file: File) {
    const ext = this.getFileExtension(file.name);
    const icon = this.fileIcons[ext];
    return icon ? icon : 'assets/svg/file-doc.svg';
  }

  private getFileExtension(filename: string): string {
    return filename.split('.').pop()?.toLowerCase() || '';
  }

  isImage(file: File): boolean {
    return /^image\//.test(file.type);
  }

}
